import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { choosePhoneFromList } from './mobile-steps'
import {
  chooseBrandsAndroidPhoneSearch,
  chooseBrandsPhoneSearch,
  choosePhoneCondition,
  chooseBrandsProprietaryPhoneSearch,
  choosePhoneOsPhoneSearch,
  currentProviderMobilePhoneSearch,
  provincesStepPhoneSearch,
  provincesStepPhoneSearchWithCurrentProvider,
} from './phone-search-steps'

export const phoneSearchScenarioA: Scenario = {
  id: 'phone-search-a',
  initialStep: Steps.CHOOSE_PHONE_OS,
  type: ScenarioType.PHONE_SEARCH,
  version: '1',
  milestones: [
    choosePhoneOsPhoneSearch.id,
    chooseBrandsPhoneSearch.id,
    choosePhoneCondition.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStepPhoneSearch,
    choosePhoneOsPhoneSearch,
    chooseBrandsPhoneSearch,
    chooseBrandsAndroidPhoneSearch,
    chooseBrandsProprietaryPhoneSearch,
    choosePhoneCondition,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const phoneSearchScenarioB: Scenario = {
  ...phoneSearchScenarioA,
  id: 'phone-search-b',
  initialStep: Steps.PROVINCE,
  milestones: [
    provincesStepPhoneSearchWithCurrentProvider.id,
    currentProviderMobilePhoneSearch.id,
    choosePhoneOsPhoneSearch.id,
    chooseBrandsPhoneSearch.id,
    choosePhoneCondition.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStepPhoneSearchWithCurrentProvider,
    currentProviderMobilePhoneSearch,
    choosePhoneOsPhoneSearch,
    chooseBrandsPhoneSearch,
    chooseBrandsAndroidPhoneSearch,
    chooseBrandsProprietaryPhoneSearch,
    choosePhoneCondition,
    choosePhoneFromList,
  ],
  weight: 1,
}
